/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_New_DateInputs */

const en_cad_field_new_date = /** @type {(inputs: Cad_Field_New_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New date`)
};

const ja_cad_field_new_date = /** @type {(inputs: Cad_Field_New_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日付`)
};

const fr_cad_field_new_date = /** @type {(inputs: Cad_Field_New_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle date`)
};

const de_cad_field_new_date = /** @type {(inputs: Cad_Field_New_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Termin`)
};

/**
* | output |
* | --- |
* | "New date" |
*
* @param {Cad_Field_New_DateInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_new_date = /** @type {((inputs?: Cad_Field_New_DateInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_New_DateInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_new_date(inputs)
	if (locale === "ja") return ja_cad_field_new_date(inputs)
	if (locale === "fr") return fr_cad_field_new_date(inputs)
	return de_cad_field_new_date(inputs)
});